// Story 45.5 (G-LAND/CG-3) — landing pós-login por role. Função PURA: o dia da
// profissional começa na agenda; admin/secretary/owner mantêm o dashboard (byte a
// byte o comportamento atual). Role desconhecida cai no default seguro.
export function landingFor(role: string | null | undefined): string {
  return role === 'professional' ? '/agendamentos' : '/dashboard';
}
